import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('centroUser');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
      } catch (e) {
        localStorage.removeItem('centroUser');
      }
    }
    setLoading(false);
  }, []);

  const login = async (userId, password) => {
    const result = await api.login(userId, password);
    if (result.success) {
      const userData = { userId: result.userId, balance: result.balance };
      setUser(userData);
      localStorage.setItem('centroUser', JSON.stringify(userData));
    }
    return result;
  };

  const register = async (userId, password) => {
    const result = await api.register(userId, password);
    if (result.success) {
      // Auto-login after registration
      return login(userId, password);
    }
    return result;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('centroUser');
  };

  const updateBalance = (newBalance) => {
    if (user) {
      const updatedUser = { ...user, balance: newBalance };
      setUser(updatedUser);
      localStorage.setItem('centroUser', JSON.stringify(updatedUser));
    }
  };

  const value = {
    user,
    loading,
    login,
    register,
    logout,
    updateBalance,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export default AuthContext;
